if (document.querySelector('.accordion')) {
	var agendaId = getParameterByName("a");
	// if an agenda exists on the page and the query parameter exists, scroll to that agenda item
	if (agendaId && document.getElementById("agenda")) {
		var agendaTop = document.getElementById(agendaId).getBoundingClientRect().top;
		window.scroll(0, document.documentElement.scrollTop + agendaTop);
	}

	document.querySelectorAll('.accordion').forEach((a) => {
		const toggleSeparate = a.getAttribute('data-toggle-separate');
		const accordionTabs = a.querySelectorAll('.js-accordion-tab');
		const toggleAll = a.querySelector('.js-accordion-toggle-all');
		// Open fn
		const openTab = (element) => {
			// if (!detectMobile() && element.closest('.js-accordion-mobile')) return;
			element.setAttribute('data-open', true);
			// Make button tabable
			if (element.querySelector('.button')) {
				element.querySelector('.button').removeAttribute('tabindex');
			}
			// Accessibility
			element.removeAttribute('aria-hidden');
			element.setAttribute('aria-selected', true);
		};
		// Close fn
		const closeTab = (element) => {
			element.removeAttribute('data-open');
			// Make button tabable
			if (element.querySelector('.button')) {
				element.querySelector('.button').setAttribute('tabindex', '-1');
			}
			// Accessibility
			element.removeAttribute('aria-selected');
			element.setAttribute('aria-hidden', true);
		};
		// Toggle fn
		const accordionToggle = (thisTab) => {
			// Check if open
			if (thisTab.getAttribute('data-open')) {
				closeTab(thisTab);
			}
			// Else
			else {
				if(!toggleSeparate) {
					for (var i = accordionTabs.length - 1; i >= 0; i--) {
						closeTab(accordionTabs[i].parentElement);
					}
				}
				openTab(thisTab);
			}
		};

		const accordionToggleAll = (thisTab) => {
			if (thisTab.getAttribute('data-open')) {
				closeTab(thisTab);
				accordionTabs.forEach((t) => {
					closeTab(t.parentElement);
				});
			} else {
				openTab(thisTab);
				accordionTabs.forEach((t) => {
					openTab(t.parentElement);
				});
			}
		};

		// Add Event Listeners
		['click', 'keypress'].forEach((listener) => {
			for (var i = accordionTabs.length - 1; i >= 0; i--) {
				accordionTabs[i].addEventListener(listener, (event) => {
					// Keypress 'Enter'
					if (event.type === 'keypress' && event.keyCode === 13) {
						accordionToggle(event.currentTarget.parentElement);
					}
					// Or Click
					else if (event.type === 'click') {
						accordionToggle(event.currentTarget.parentElement);
					}
				}, false);
			}
			if(toggleAll) {
				toggleAll.addEventListener(listener, (event) => {
					if(event.type === 'keypress' && event.keyCode === 13) {
						accordionToggleAll(event.currentTarget.parentElement);
					} else if (event.type === 'click') {
						accordionToggleAll(event.currentTarget.parentElement)
					}
				}, false);
			}
		});
	})

}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}


// WEBPACK FOOTER //
// ../components/accordion/accordion.js